import { RegistrationFeesType } from '../event-fees/event-fees.interface'
import { IAnswer } from '../event-registered-users/event-registered-users.interface'
import { IEventInterface } from '../events/event.interface'
import { IHorseTeamInterface } from '../horse-team/horseTeam.interface'
import { IHorseData } from '../horse/horse.interface'
import { IUserInterface } from '../users/user.interface'
import { IPaymentStatus, IPaymentType } from '../../types/payment'
import { IScoreCardSection, IScoreCardType } from '../score-cards/score-cards.interface'

export const HORSE_NAME_DEFAULT = 'No Horse'

export interface ISheetSection {
  name: string
  max: number
  type: string
  rows: {
    number?: number
    description: string
    score: number | string
    coefficient?: number
    remarks?: string
    fraction?: string
  }[]
  notice?: string
}

export interface IJudge {
  id: string
  name: string
  picture: string

  furtherRemarks: string

  // related with dummy sheets score cards
  errors?: number
  sections: ISheetSection[]

  // related with 'hunter-jumper' score cards
  customSections: IScoreCardSection[]
  isWithdrew?: boolean
  showJumpOff?: boolean
  fenceHeight?: string

  signatureDate: Date | string | null
  signatureUrl: string | null
}

export type ScoreTypes = {
  totalPoints?: number | string | null
  judges?: IJudge[] | null
  sheet?: {
    name: string
    type: IScoreCardType
  } | null
  details?: string | null
  rank?: number | string | null
  file?: string | null
  earning?: string | null
}

export interface IComment {
  id: string
  questionId: string
  comment: string
  files: string[]
}

export interface IRegistrationByDayInterface {
  v?: number
  /** @info Id of the event in which the competitor is registering */
  eventId: string | null
  /** @info Id of the registration to which this registration belongs */
  registrationDocId: string | null
  /** @info `true` specifies that the scratch amount have been added in the recipient doc */
  scratchAmountAdded?: boolean
  /** @info `true` specifies that the refund amount have been added in the recipient doc */
  refundAmountAdded?: boolean
  /** @info Id of the user creating this registration --[COMPETITOR] */
  userId: string | null
  /** @info Actual id of the horse in horses table */
  horseId: string | null
  /** @info Id of mapping form user-horse-mapping table */
  userHorseMappingDocId: string | null
  /** @info Id of the team member being registered as rider as per this registration */
  riderId: string | null
  /** @info Email id of the person who have been added under horse as rider */
  riderEmail: string | null
  /** @info Name of the person who have been added under horse as rider */
  riderName?: IUserInterface['userName'] | null
  /** @info Dob of the person who have been added under horse as rider */
  riderDob?: IUserInterface['userDOB'] | string | null
  /** @info To be used on client side side only, update true means the doc needs and update */
  update?: boolean
  /** @info To be used on client side side only, teamMembersAvailable true means team members were added against the rider*/
  teamMembersAvailable?: boolean
  paymentStatus: IPaymentStatus
  paymentType: IPaymentType
  /** @info Specifies wether the item is scratched or not */
  isScratched: boolean
  /** @info Invoice id of the invoice generated which payment */
  invoiceId?: string | null
  /** @info Invoice url of the invoice generated which payment */
  invoiceUrl?: string | null
  /** @info Amount that is refunded, Once the item is scratched the amount can be refunded, max value should be equal to `registrationPrice` */
  amountRefunded: number
  /** @info The id of the document in `Refund Collection` */
  refundDocId: string | null
  /** @info The id of the refund request from stripe */
  refundId: string | null
  /** @info Specifies how much amount is scratched */
  amountScratched: number
  /** @info Name of the event this document is related to */
  eventName?: string | null
  /** @info if the payment is refunded then this will be `refunded` else `null` */
  refundStatus: 'refunded' | null
  /** @info if the payment is refunded then this will be `refunded` else `null` */
  score: ScoreTypes | null
  /** Order for class/rider-based scheduling */
  order: number
  /** @info this is used only when handling scheduling the ride time for day based rider scheduling, registration level storage */
  // optional fee prop to support rider scheduling logic where we want to have a reference to the correct fee
  fee?: RegistrationFeesType | null
  rideTime?: string | null
  orderOfGoScratched?: boolean
  /** @info Specifies back number */
  backNumber: number
  /** @info Name of the horse */
  horseName?: IHorseTeamInterface['horseName']
  /** @info Role of the person who have been added under horse as team member */
  riderRole?: string | null
  /** @info Id of the recipient who have paid the amount for this registration */
  recipientId?: string | null
  /** @inteface IUserInterface `userNameNGram` */
  recipientNameNGram?: string[]
  /** @info Name of the recipient */
  recipientName?: string | null
  /** @info Profile picture of the recipient */
  recipientProfilePicture?: IUserInterface['userProfilePicture'] | null
  /** @inteface IUserInterface `userNameNGram` */
  riderNameNGram?: string[]
  /** @info Profile pic of horse */
  horseProfilePicture?: IHorseData['horseProfilePicture'] | null
  /** @info registrationPrice for the event to which this registration belongs */
  registrationPrice: IEventInterface['eventPriceUSD'] | null
  qualifyFee: string | null
  qualifyFeeName: string | null
  breakTime: number | null
  isBreak?: boolean | null
  isQualify?: boolean | null
  /** @info registrationName for the event to which this registration belongs */
  registrationByDayName: string | null
  /** @info Id of the doc in db */
  id?: string | null

  answers?: IAnswer[]

  horseIds?: string[]

  /** @info Profile picture of the rider */
  riderProfilePicture?: IUserInterface['userProfilePicture'] | null
  /** @info Virtual date to which this registration is related */
  eventDate?: Date | string | null
  /** @info Time of document creation in db */
  created?: Date | string | null
  /** @info Time of document modification in db */
  modified?: Date | string | null
  divisionUniqId?: string | null
  isDivision?: boolean | null
  uuid: string | null
  uniqId?: string | null
}

export type IRegistrationByDayTypes = {
  IRegistrationByDayInterface: IRegistrationByDayInterface
}

export default IRegistrationByDayTypes
